<template>
  <div class="orderbox">
    <form class="main-wrap">
      <div class="firstTitle">基本信息</div>
      <!-- 表格部分 -->
      <vs-row class="pad24">
        <vs-col vs-w="0.8" class="colTitle"
          ><span class="redText">*</span>选择订单渠道</vs-col
        >
        <vs-col vs-w="2">
          <v-select
            v-validate="'required'"
            :options="orderChannelList"
            v-model="orderInfo.sourceChannel"
            label="val"
            :reduce="(opt) => opt.key"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
            placeholder="请选择订单渠道"
            @input="selectOrderChannel"
          />
        </vs-col>

        <vs-col vs-w="0.8" class="colTitle" vs-offset="0.5">需求部门</vs-col>
        <vs-col vs-w="2">
          <vs-input
            v-model="orderInfo.fromDepart"
            class="w-full"
            placeholder="请输入需求部门"
            v-validate="'required'"
          />
        </vs-col>

        <vs-col vs-w="0.8" class="colTitle" vs-offset="0.5">需求人员</vs-col>
        <vs-col vs-w="2">
          <vs-input
            v-model="orderInfo.fromUser"
            class="w-full"
            placeholder="请输入需求人员"
            v-validate="'required'"
          />
        </vs-col>
      </vs-row>

      <vs-row class="pad24 marTop20">
        <vs-col vs-w="0.8" class="colTitle">订单编号</vs-col>
        <vs-col vs-w="2">
          <vs-input
            v-model="orderInfo.orderNo"
            disabled
            class="w-full"
            placeholder="请输入订单编号"
            v-validate="'required'"
          />
        </vs-col>

        <vs-col vs-w="0.8" class="colTitle" vs-offset="0.5">线下PI号</vs-col>
        <vs-col vs-w="2">
          <vs-input
            v-model="orderInfo.piNo"
            class="w-full"
            placeholder="请输入线下PI号"
            v-validate="'required'"
          />
        </vs-col>
      </vs-row>

      <vs-row class="pad24 marTop20">
        <vs-col vs-w="0.8" class="colTitle"
          ><span class="redText">*</span>买家类型</vs-col
        >
        <vs-col vs-w="2">
          <v-select
            :options="buyerTypeList"
            v-model="orderInfo.buyerType"
            @input="onSelectedBuyerType"
            :reduce="(opt) => opt.label"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
            placeholder="请关联买家类型"
          >
            <div slot="no-options">暂无选项</div>
          </v-select>
        </vs-col>
        <vs-col vs-w="0.8" class="colTitle" vs-offset="0.5"
          ><span class="redText">*</span>买家名称</vs-col
        >
        <vs-col vs-w="2" style="width: 300px">
           <v-select
            :options="buyerNameList"
            v-model="orderInfo.buyerName"
            @input="onSelectedBuyerName"
            label="label"
            placeholder="请关联买家类型"
          >
            <div slot="no-options">暂无选项</div>
          </v-select>
<!--          <el-select-->
<!--            filterable-->
<!--            remote-->
<!--            v-model="orderInfo.buyerName"-->
<!--            @change="getbuysname"-->
<!--            :remote-method="onSelectedBuyerName"-->
<!--            value-key="id"-->
<!--            placeholder="请关联买家类型">-->
<!--            <el-option-->
<!--              v-for="item in buyerNameList"-->
<!--              :key="item.id"-->
<!--              :label="item.label"-->
<!--              :value="item">-->
<!--            </el-option>-->
<!--          </el-select>-->
          <!--                    <vs-input v-model.trim='orderInfo.buyerName' class="w-full" placeholder="请输入买家名称" v-validate="'required'"/>-->

          <!-- <vue-simple-suggest
                            v-model="orderInfo.buyerName"
                            :list="getBuyerType"
                            :filter-by-query="true"
                            :debounce="200"
                            @select="onSuggestSelect"
                            class="client-name"
                            placeholder="请输入客户名称"
                            ref="suggest"
                    /> -->
        </vs-col>
      </vs-row>

      <div class="firstTitle">订单收货地址</div>
      <!-- 表格部分 -->
      <vs-row class="pad24">
        <vs-col vs-w="0.8" class="colTitle"
          ><span class="redText">*</span>收货地址</vs-col
        >
        <vs-col vs-w="3.5">
          <el-cascader
            size="large"
            :options="options"
            v-model="selectedOptions"
            @change="handleChange"
          >
          </el-cascader>
        </vs-col>
        <!-- <vs-col vs-w="1.2">
                    <vs-input v-model='orderInfo.province'  class="w-full" placeholder="请输入需求省份"/>
                </vs-col>

                <vs-col vs-w="1.5" vs-offset="0.2">
                    <vs-input v-model='orderInfo.city'  class="w-full" placeholder="请输入市"/>
                </vs-col>

                <vs-col vs-w="1.5" vs-offset="0.2">
                    <vs-input v-model='orderInfo.area'  class="w-full" placeholder="请输入县/区"/>
                </vs-col> -->

        <vs-col vs-w="3" vs-offset="0.2">
          <vs-input
            v-model="orderInfo.address"
            class="w-full"
            placeholder="请输入详细地址"
          />
        </vs-col>
      </vs-row>
      <vs-row class="pad24 marTop20">
        <vs-col vs-w="0.8" class="colTitle"
          ><span class="redText">*</span>收货人名</vs-col
        >
        <vs-col vs-w="2">
          <vs-input
            v-model="orderInfo.receiveName"
            class="w-full"
            placeholder="请输入收货人名"
          />
        </vs-col>
      </vs-row>

      <vs-row class="pad24 marTop20">
        <vs-col vs-w="0.8" class="colTitle"
          ><span class="redText">*</span>联系方式</vs-col
        >
        <vs-col vs-w="2">
          <vs-input
            v-model="orderInfo.receivePhone"
            type="tel"
            maxlength="11"
            @blur="testBTN"
            class="w-full"
            placeholder="请输入联系方式"
          />
        </vs-col>
      </vs-row>

      <div class="firstTitle">留言备注</div>
      <!-- 表格部分 -->
      <vs-row class="pad24">
        <vs-col vs-w="0.8" class="colTitle">买家备注</vs-col>
        <vs-col vs-w="10">
          <vs-input
            v-model="orderInfo.buyerRemark"
            maxlength="200"
            class="w-full"
            placeholder="请输入买家留言"
            v-validate="'required'"
          />
        </vs-col>
      </vs-row>

      <vs-row class="pad24 marTop20">
        <vs-col vs-w="0.8" class="colTitle">卖家备注</vs-col>
        <vs-col vs-w="10">
          <vs-input
            v-model="orderInfo.sellerRemark"
            maxlength="200"
            class="w-full"
            placeholder="请输入卖家留言"
          />
        </vs-col>
      </vs-row>

      <div class="firstTitle">订单商品信息</div>
      <vs-row class="pad24">
        <vs-col>
          <skuListAdd
            :orderNo="orderInfo.orderNo"
            :sourceChannel="orderInfo.sourceChannel"
            :editFlag="true"
            ref="skuItem"
            :newOrder="true"
            @getPayInfo="getPayInfo"
            :buyer="orderInfo.buyer"
            :buyerTypeNum="buyerTypeNum"
            :orderGoodsList="storageSkuData"
            :payTypeList="orderInfo.payRecords"
            :addcustype="addcustype"
          ></skuListAdd>
          <!-- <order-goods-List class='goods_wrap' :buyer = "orderInfo.buyer" @getPayInfo='getPayInfo'></order-goods-List> -->
        </vs-col>
      </vs-row>
    </form>

    <div class="option-wrap">
      <vs-button type="filled" @click="submitCreate">确认创建</vs-button>
      <vs-button type="border" class="marLeft16" @click="cancleAffirm"
        >取消</vs-button
      >
    </div>
  </div>
</template>

<script>
import { Mod_Account } from "@/modules/server-api/Accounts";
import { Mod_Stores } from "@/modules/server-api/Stores";
import store from "./store.js";
import filterBox from "./filterBox.vue";
import addModal from "./addModal.vue";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import vSelect from "vue-select";
import { OrderApi } from "@/modules/server-api/commodity-sys/order";
import GcCmpFormSelect from "../../group-cloud/components/form/select/GC-Cmp-Select";
import VueSimpleSuggest from "vue-simple-suggest";
import "vue-simple-suggest/dist/styles.css";
import skuListAdd from "@/modules/order/orderDetail/skuListAdd";
// import { regionData, CodeToText, TextToCode } from 'element-china-area-data'
import {
  regionDataPlus,
  CodeToText,
  TextToCode,
} from "element-china-area-data";
import {
  OnShelvesApi,
  Customer_Types_Opts,
} from "@/modules/server-api/commodity-sys/on-shelves";
export default {
  components: {
    VueSimpleSuggest,
    GcCmpFormSelect,
    flatPickr,
    "v-select": vSelect,
    filterBox,
    addModal,
    skuListAdd,
  },
  mixins: [store],
  data() {
    return {
      buyer_list: [],
      filtered_buyers: [],
      addcustype:'',
      orderInfo: {
        //idx: 0,
        buyer: "",
        sourceChannel: "",
        buyerName: "",
        province: '',
        city: '',
        area: '',
      },
      orderChannelList: [],
      // buyerTypeList:Customer_Types_Opts, //买家类型
      buyerTypeList: [], //买家类型
      buyerTypeNum: "", //买家类型 0门店 1客户
      buyerNameList: [],
      searchTimer: null,
      options: regionDataPlus,
      allText: "全部",
      otherText: "其他",
      selectedOptions: [],
      storageSkuData: [], //缓存的商品信息
    };
  },
  computed: {
    getBuyList() {
      return this.buyer_list;
    },
  },
  created() {
    //移除缓存的信息
          sessionStorage.setItem("sessionOrderInfo", {});
          sessionStorage.setItem("addSkuItemList", []);
    this.getOrderChannel();
    this.options.forEach((item) => {
      if (item.children && item.children.length > 0) {
        // console.log('item',item.children)
        let itemList = item.children;
        itemList.forEach((element) => {
          // if (element.label == '全部') {
          //   element.label = '其他'
          // }
          if (element.children && element.children.length > 0) {
            let list = element.children;
            list.forEach((ele) => {
              if (ele.label == this.allText) {
                ele.label = this.otherText;
                element.children.push(ele);
                element.children.shift();
              }
            });
          } else {
            element.label =
              element.label == this.allText
                ? (element.label = this.otherText)
                : element.label;
          }
        });
      } else {
        item.label =
          item.label == this.allText
            ? (item.label = this.otherText)
            : item.label;
      }
    });
    //判断是否有缓存的订单信息
    if (sessionStorage.getItem("sessionOrderInfo")) {
      this.orderInfo = JSON.parse(sessionStorage.getItem("sessionOrderInfo"));
      console.log(this.orderInfo)
      this.selectOrderChannel();
      //处理地址等信息渲染
      this.showStorageInfo();
    }
  },
  methods: {
    testBTN(){
      console.log(this.orderInfo);
    },
    //选择进货渠道
    selectOrderChannel() {
      console.log(this.orderInfo.sourceChannel);
      if (
        this.orderInfo.sourceChannel &&
        this.orderInfo.sourceChannel == "TEL"
      ) {
        this.buyerTypeList = [
          { id: 76, label: "一次性客户", type: 0 },
          { id: 77, label: "内部客户", type: 0 },
          { id: 78, label: "海外客户", type: 0 },
        ];
      } else if (
        this.orderInfo.sourceChannel == "NEW_ACCESS" ||
        this.orderInfo.sourceChannel == "NEW_ACCESS_CON"
      ) {
        let data = {
          level: 1,
          cus_type: 1,
          customer_code: "XT",
        };
        this.getBuyertype(data);
      } else if (
        this.orderInfo.sourceChannel == "STORE_GOODS" ||
        this.orderInfo.sourceChannel == "STORE_ANTI_GOODS" ||
        this.orderInfo.sourceChannel == "STORE_MAN"
      ) {
        let data = {
          level: 1,
          cus_type: 2,
        };
        this.getBuyertype(data);
      } else {
        // this.buyerTypeList = Customer_Types_Opts;
        let data = {};
        this.getBuyertype(data);
      }
    },
    //订单渠道查询
    async getOrderChannel() {
      let res = await OrderApi.getOrderChannel();
      this.orderChannelList = res.result;
    },
    //买家类型
    async getBuyertype(data) {
      this.buyerTypeList = [];
      let res = await OrderApi.getBuyertype(data);
      console.log(res);
      res.result.map((item) => {
        this.buyerTypeList.push({
          id: item.id,
          label: item.customer_name,
          type: item.cus_type ? (item.cus_type == 1 ? 0 : 1) : 0,
          cus_type:item.cus_type
        });
      });

      if ( data.cus_type === 2 ){
        this.buyerTypeList = this.buyerTypeList.filter(item =>{
            return item.label === '门店客户' || item.label === '内部客户';
        })
      }
      console.log(this.buyerTypeList, "getBuyertype");
    },
    //省市区联动信息处理
    handleChange(addressArr) {
      if (addressArr.length > 0) {
        this.orderInfo.province = CodeToText[addressArr[0]];
        this.orderInfo.city = CodeToText[addressArr[1]];

        let currArea =
          CodeToText[addressArr[2]] == this.allText
            ? this.otherText
            : CodeToText[addressArr[2]];
        this.orderInfo.area = currArea;
        // console.log('地址信息',this.orderInfo.area)
        this.cacheOrderInfo();
      }
    },
    //缓存订单信息
    cacheOrderInfo() {
      // console.log(this.orderInfo);
      sessionStorage.setItem(
        "sessionOrderInfo",
        JSON.stringify(this.orderInfo)
      );
    },
    // onSuggestSelect(val) {

    //     // console.log(['select', val]);

    //     //this.orderInfo.idx = null;
    //     let idx;

    //     for (idx = 0; idx < this.filtered_buyers.length; idx++) {
    //         if (this.filtered_buyers[idx].name === val) {
    //             // this.buyerTypeList = [ {id: this.filtered_buyers[idx].id, label: this.filtered_buyers[idx].type} ];
    //             this.buyerTypeList = [ this.filtered_buyers[idx].type ];
    //             this.orderInfo.buyer = this.filtered_buyers[idx].id;
    //             //this.orderInfo.idx = 0;
    //         }

    //     }

    //     console.log(['type:', this.buyerTypeList[0]]);

    // },
    //买家类型
    // async getBuyerType() {
    //     let res = await OrderApi.getBuyerType({search:this.orderInfo.buyerName});
    //     // this.buyerTypeList = [];
    //     // this.buyerTypeList = res.result.list;
    //     //this.orderInfo.idx;
    //     // console.log(this.buyerTypeList);
    //     let data = this.convertAutoComplete(res.result.list);
    //     this.buyer_list = data.list;
    //     this.filtered_buyers = data.filtered;
    //     return this.buyer_list;
    // },
    // convertAutoComplete(rawList) {
    //     let idx, filtered = [], list = [], needle = this.orderInfo.buyerName;

    //     for (idx = 0; idx < rawList.length; idx++) {

    //         if (rawList[idx].name.indexOf(needle) !== -1) {
    //             filtered.push(rawList[idx]);
    //             list.push(rawList[idx].name);
    //         }
    //     }

    //     return  {
    //         filtered: filtered,
    //         list: list
    //     };
    // },

    // changeBuyerType(val){
    //     console.log(this.orderInfo.buyerType,"455454")
    //     if(this.orderInfo.buyerName == ""){
    //         this.$notifyError('请输入买家类型');
    //         this.buyerTypeList = [];
    //         this.orderInfo.buyerType = ""
    //     }
    // },

    //获取增加的支付信息
    getPayInfo(info) {
      if (info && info.length) {
        this.orderInfo.payRecords = [...info];
        this.cacheOrderInfo();
      }
    },

    //创建订单
    async submitCreate() {
      var that = this
      const {
        sourceChannel,
        buyerName,
        buyer,
        province,
        city,
        area,
        address,
        receiveName,
        receivePhone,
      } = this.orderInfo;
      console.log(buyer)
      if (!sourceChannel) {
        return this.$notifyError("请选择订单渠道");
      }
      if (!buyerName) {
        return this.$notifyError("请输入客户名称");
      }
      if (!province || !city || !address || !receiveName || !receivePhone) {
        return this.$notifyError("请完善订单收货地址信息");
      }
      if (province != "香港特别行政区" && province != "澳门特别行政区") {
        if (!area) {
          return this.$notifyError("请选择区/县");
        }
      }
      var pattern = /^1{1}[0-9]{10}$/;
      if (receivePhone.split("").length != 11) {
        return this.$notifyError("请输入11位联系方式！");
      } else {
        if (!pattern.test(receivePhone)) {
          return this.$notifyError("请输入正确的联系方式！");
        }
      }
      console.log([1, this.orderInfo.buyer]);
      if (this.orderInfo.buyer == undefined) {
        return this.$notifyError('请选择买家类型');
      }
      //买家类型只能选择一个 先注释 有问题再放开
      // this.buyerTypeList.forEach((item,index)=>{
      //     if(item.id == this.orderInfo.buyer){
      //         this.orderInfo.buyerType = item.type
      //     }
      // })
      let skuItems = sessionStorage.getItem("addSkuItemList");
      console.log(skuItems)
      if (!skuItems) {
        return this.$notifyError("请添加商品信息");
      } else {
        this.orderInfo.skuItems = JSON.parse(skuItems);
      }
      // console.log('this.orderInfo',this.orderInfo)
      if (this.orderInfo.area == this.allText) {
        this.orderInfo.area = this.otherText;
      }
      let param = {};
      param = this.orderInfo;
      if(this.buyerTypeNum == 1){
        param.buyer = 'store' + param.buyer
      }

      // if(this.$refs["skuItem"].payTypeList.length==0){
      //   this.$confirm('未添加支付信息，是否继续审核?', '提示', {
      //     confirmButtonText: '确定',
      //     cancelButtonText: '取消',
      //     type: 'warning'
      //   }).then(() => {
      //     that.getadd(param);
      //   }).catch(() => {});
      // }else{
        console.log( this.$refs['skuItem'].splitGoodsList)

      param.skuItems.forEach(item=>{
        if(item.hunitPrice == 0){
          item.untilPrice = item.returnMoney;
          item.itemPrice = isNaN(item.untilPrice) ? 0 : Number(item.num) * Number(item.untilPrice);
        }
      })
        let resp = await OrderApi.createNewOrder(param);
        if (resp.succ == 1) {
          this.$notifySuccess("创建订单成功");
          //移除缓存的信息
          sessionStorage.setItem("sessionOrderInfo", {});
          sessionStorage.setItem("addSkuItemList", []);
          this.$router.push({ path: "/modules/order/order" });
        } else {
          return this.$notifyError(resp.error);
        }
      // }
      console.log(param.payRecords)

    },
    async getadd(param){
      let resp = await OrderApi.createNewOrder(param);
      if (resp.succ == 1) {
        this.$notifySuccess("创建订单成功");
        //移除缓存的信息
        sessionStorage.setItem("sessionOrderInfo", {});
        sessionStorage.setItem("addSkuItemList", []);
        this.$router.push({ path: "/modules/order/order" });
      } else {
        return this.$notifyError(resp.error);
      }
    },

    clearTimer() {
      if (this.searchTimer) {
        clearTimeout(this.searchTimer);
      }
    },
    //获取客户类型
    async getCustomerData(type) {
      console.log('订单渠道',this.orderInfo.sourceChannel)
      console.log('买家类型',type);
      let pager = {
        page: 1,
        num: 9999999, //后续需要改成不分页的
        total: 0,
      };
      if (type.length > 0) {
        this.buyerNameList = [];
        let resp;
        if (type == "门店客户") {
          type = 3;
          resp = await Mod_Account.getList(pager.page, type,this.orderInfo.buyerName);
          console.log(resp);
          if (resp) {
            let resData = resp;
            if (resData.length > 0) {
              //组装数据
              resData.map(async (item, index) => {
                let obj = {};
                obj.id = item.id;
                //   let res = await Mod_Account.loadUser(item.role_id)
                // console.log('9999999',res)
                // loadUser
                obj.label = item.name || item.realname;
                obj.buyerCode = item.out_code;
                this.buyerNameList.push(obj);
                // let arr = []
                // arr.push(obj)
              });
              // console.log(this.buyerNameList);
               resp = await Mod_Stores.getUserStores(this.buyerNameList);
              // console.log('9999999',resp)
            }
          }
        }else if(this.orderInfo.sourceChannel=='STORE_ANTI_GOODS' || this.orderInfo.sourceChannel=='STORE_GOODS'){
          // resp = await OnShelvesApi.getClientList(pager.page, pager.num, );
          let user_type = 3;
          resp = await OnShelvesApi.getClientList(pager.page, pager.num, user_type);
        } else if(type == '集合店' || type == '专柜店' || type == '专卖店' || type == '明星店' || type == '星柚专卖店' || type == '直营店') {
          resp = await OnShelvesApi.getStoreList(pager.page, pager.num, [type]);
        } else {
          resp = await OnShelvesApi.getClientList(pager.page, pager.num, [type]);
        }
        //筛选门店
        console.log('++++++++++++++++++++++++++++++++')
        console.log(resp)
        if (resp) {
          let resData = resp;
          // console.log('8888888',resData)
          if (resData.length > 0) {
            //组装数据
            resData.map(async (item, index) => {
              let obj = {};
              obj.id = item.id;
              if (type == 3) {
                //   let res = await Mod_Account.loadUser(item.role_id)
                // console.log('9999999',res)
                // loadUser
                obj.label = item.realname;
              } else {
                obj.label = item.name;
              }

              obj.buyerCode = item.out_code;
              this.buyerNameList.push(obj);
            });
          }
        }
      } else {
        this.$notifyError("请先选择买家类型");
      }
    },

    //选择买家类型
    onSelectedBuyerType(val) {
      this.buyerTypeList.map((item) => {
        if (item.label == val) {
          this.buyerTypeNum = item.type;
          this.addcustype = item.cus_type
        }
      });
      console.log(val)
      this.orderInfo.buyerName = "";
      console.log(this.addcustype)
      this.getCustomerData(val);
    },
    getbuysname(val){
      this.orderInfo.buyerName = val.label;
      this.orderInfo.buyer = val.id;
      this.orderInfo.buyerCode = val.buyerCode;
    },
    //选择买家名称
    onSelectedBuyerName(val) {
      this.orderInfo.buyerName = val.label;
      this.orderInfo.buyerCode = val.buyerCode;
      this.orderInfo.buyer = val.id;
      // console.log(85555555555)
      // if(val>0){
      //  let asd = this.getCustomerData(this.orderInfo.buyerType)
      //  console.log('asd',asd)
      // }
    },
    //地址信息渲染
    showStorageInfo() {
      //地址信息
      console.log(this.orderInfo.province)
      if (this.orderInfo.province != "") {
        let currArea =
          this.orderInfo.area == this.otherText
            ? this.allText
            : this.orderInfo.area;
        // console.log('==this.orderInfo==', this.orderInfo);
        let currAddressCode =
          TextToCode[this.orderInfo.province][this.orderInfo.city][currArea]
            .code;
        // console.log('currAddressCode收货地址信息',currAddressCode)
        this.selectedOptions = currAddressCode;
      }

      //商品信息
      if (sessionStorage.getItem("addSkuItemList")) {
        this.storageSkuData = JSON.parse(
          sessionStorage.getItem("addSkuItemList")
        );
      }
      console.log("===商品信息-===", this.storageSkuData);
    },
    // 确认取消
    cancleAffirm() {
      this.$vs.dialog({
        type: "confirm",
        title: `请确认`,
        text: `是否确认取消`,
        acceptText: "确认",
        cancelText: "取消",
        accept: () => {
          this.cancelOrderInfo();
        },
      });
    },
    cancelOrderInfo() {
      sessionStorage.setItem("addSkuItemList", []);
      sessionStorage.setItem("sessionOrderInfo", {});
      this.$router.push({ path: "/modules/order/order" });
    },
  },

  watch: {
    // 'orderInfo.buyerName'(val) {
    //     this.clearTimer();
    //     this.getBuyerType();
    //     this.searchTimer = setTimeout(() => {
    //         if(val){
    //             // this.getBuyerType();
    //         }
    //     }, 500);
    // }
    orderInfo: {
      handler(val, oldVal) {
        //缓存信息
        this.cacheOrderInfo();
      },
      deep: true,
    },
    "orderInfo.sourceChannel"(val){
      this.orderInfo.buyerType = "";
      this.orderInfo.buyerName = "";
      this.storageSkuData = [];
      sessionStorage.removeItem('addSkuItemList');
      this.$refs.skuItem.splitGoodsList = {};
    }
  },
};
</script>

<style lang="scss" scoped>
// @import '../order/order.scss';
@import "@/modules/commodity-sys/commodity.scss";
.deliver-pop {
  /deep/ .v-select {
    width: 350px;
  }
}
.colTitle {
  line-height: 37px;
}
.deliver-btn {
  width: 100%;
  button {
    width: 126px;
    height: 38px;
    font-size: 14px;
  }
}
.edit-remark-textarea {
  width: 100%;
}
.main-wrap {
  background-color: #fff;
  border-radius: 6px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  padding-bottom: 20px;
}
.vs-row {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  // height: 38px;
  // line-height: 38px;
  color: #5e5873;
  font-size: 14px;
  .vs-col {
    display: flex;
    align-items: center;
    justify-content: center;
    .redText {
      margin-right: 8px;
    }
    .dropCategory {
      width: 100%;
    }
  }
  /deep/ .input-span-placeholder.vs-input--placeholder.normal {
    text-align: left;
  }
  /deep/ .v-select.vs--single.vs--searchable {
    width: 100%;
  }
}
.con-vs-dropdown--menu.vs-dropdown-menu {
  width: 24%;
}
// 表单
form {
  .vs-input {
    width: 200px;
    height: 38px;
    line-height: 19px;
  }
}
.groupWrap {
  display: flex;
  .titleText {
    display: flex;
    .redText {
      width: 16px;
      height: 16px;
    }
  }
  /deep/ .con-img-upload {
    padding: 0 0.6rem;
  }
  /deep/ .con-input-upload,
  /deep/ .img-upload {
    margin: 0 16px;
  }
}
.imgTip {
  margin: 8px 0 40px 96px;
}

.specWrap {
  display: flex;
  margin-top: 20px;
  .redText {
    margin-right: 8px;
  }
}
.firstTitle {
  padding: 0 24px;
  &:not(:first-child) {
    border-top: 1px solid #d8d6de;
    margin-top: 40px;
  }
}
.pad24 {
  padding: 0 24px;
}
.pad10 {
  padding: 0 10px;
}
.option-wrap {
  padding: 24px;
  box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.05);
}
.marLeft105 {
  margin-left: 105px;
}
.marginR16 {
  margin-right: 16px;
}
tr {
  z-index: 100;
}

.attrHead {
  background-color: #f3f2f7;
  height: 38px;
  line-height: 38px;
  .vs-col {
    color: #5e5873;
  }
}
.attr-wrap {
  padding: 0 24px;
  margin-bottom: 40px;
  width: 615px;
  .attr-item {
    border: 1px solid #ebe9f1;
    border-top: 0;
    padding: 10px;
  }
  #addAttr {
    justify-content: flex-start;
    align-items: flex-start;
    padding-left: 14px;
  }
  .vs-row /deep/ .v-select.vs--single.vs--searchable {
    width: 150px;
  }
}
/deep/ .vs__dropdown-menu {
  position: absolute;
  z-index: 999;
  li {
    z-index: 10000;
    width: 300px;
  }
}
/deep/ .searchSelect .searchItemWrap {
  width: 350px;
}
.goods_wrap {
  margin-top: 20px;
}
/deep/ .vs-row .vs-col.colTitle {
  width: 80px !important;
}
.client-name {
  /deep/ .default-input {
    color: #626262 !important;
    border: 1px solid rgba(0, 0, 0, 0.2) !important;
  }
  /deep/ .default-input::-webkit-input-placeholder {
    color: rgba(0, 0, 0, 0.4);
    font-size: 12px;
  }
}
// 地址选择
/deep/ .el-cascader.el-cascader--large {
  width: 100%;
}
/deep/ .el-input--large .el-input__inner {
  height: 38px;
  line-height: 38px;
  border: 1px solid rgba(0, 0, 0, 0.2) !important;
}
/deep/.goods-popup .vs-table--content {
  height: calc(100vh - 300px);
}
/deep/ .el-cascader-menu__list {
  background: pink !important;
}
.el-cascader-node:first-child {
  display: none !important;
}
</style>
<style>
/* .el-cascader-menu:first-child .el-cascader-menu__list {
    background: pink !important;
  } */
.el-cascader-menu:first-child .el-cascader-node:first-child {
  display: none !important;
}
/* .el-cascader-menu:nth-child(2) .el-cascader-menu__list {
    background: pink !important;
  } */
.el-cascader-menu:nth-child(2) .el-cascader-node:first-child {
  display: none !important;
}
</style>
